
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue")
  },
  computed: {
    years() {
      let years: any = [];
      for (let i: number = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
      }
      return years;
    }
  },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
    formatMoney(val) {
      if (!val) return "";
      return String(val).formatMoney();
    }
  },
  watch: {
    $route(to, from) {
      (this as any).init();
    }
  }
})
export default class ControlZonesReport extends Vue {
  adminRoles: any = [];
  dictionary: any = {};
  title: string = "";
  filter: any = {
    companyId: "",
    controlZoneId: "",
    month: "",
    year: "",
    reporttype: "",
    branchId: "",
    trimester: "",
    status: "",
    code: "",
    requestNumber: "",
    seguredName: ""
  };
  currentRequest: number = 0;
  requests: any = [];
  companies: any = [];
  controlzones: any = [];
  branches: any = [];
  months: any = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Augosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  statuses: any = [];
  trimesters: any = [];
  limit: number = 5;
  totalRows: number = 0;
  sortColumns: Record<string, string> = {
    name: "Empresa",
    owner: "Responsable",
    deletedAt: "Estado"
  };
  currentSort: Record<string, string> = {
    col: "requests.status",
    dir: "desc"
  };

  async mounted() {
    await this.loadDictionary();
    await this.loadCompanies();
    await this.loadBranches();
    await this.init();
  }

  async init() {
    this.title = "Reporte de Solicitudes por Zona de Cúmulos";
    this.loadControlZones();
    this.loadTrimesters();
    this.loadStatuses();
    this.loadRequests(1, this.currentSort);
  }

  async exportRequests() {
    try {
      const response: any = await (this.$root as any)._post(
        "requests/exportxls",
        {
          ...this.filter
        }
      );
      window.open(response.path);
    } catch (e) {
      (this.$root as any).notify(
        "No se pudo exportar, intente más tarde.",
        "error"
      );
    }
  }

  clearFilters() {
    Object.keys((this as any).filter).forEach((key: string) => {
      (this as any).filter[key] = "";
    });
    (this as any).loadRequests(1, this.currentSort);
  }

  statusClass(status) {
    if (status === 0 || status === 1) return "active";
    if (status === 5) return "pending";
    return "inactive";
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
    this.loadRequests(page, this.currentSort);
  }

  async loadAdminRoles() {
    const response: any = await (this.$root as any)._get("admins/getroles");
    this.adminRoles = response;
  }

  async loadRequests(page: number, sort: Record<string, string>) {
    let companyIds = [];
    await this.loadAdminRoles();
    if (this.$store.state.user.type == this.adminRoles.REASEGURADOR) {
      const companies: any = await (this.$root as any)._post("companies/all", {
        adminId: this.$store.state.user.id
      });
      companies.data.forEach(company => {
        companyIds.push(company.id);
      });
    }

    this.currentSort = sort;

    if (companyIds.length > 0) {
      this.filter.companyIds = companyIds.join(",");
    }

    const response: any = await (this.$root as any)._post("requests/all", {
      limit: this.limit,
      page: page,
      order: this.currentSort,
      models: "companies",
      ...this.filter
    });
    this.totalRows = response.totalRows;
    this.requests = response.data;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post("companies/all");
    this.companies = response.data;
  }

  async loadControlZones() {
    const response: any = await (this.$root as any)._post("controlzones/all");
    this.controlzones = response.data;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadTrimesters() {
    const response: any = await (this.$root as any)._get("requests/trimesters");
    this.trimesters = response;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }
}
